(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-points"] && !Shopify.designMode) return;
  try {
    


if (list1){
list = list1;
}

var map = L.map('map', {
    center: [list[0].latitude, list[0].longitude],
    zoom: 6
});
 


var listings = document.getElementById('listings');

list.forEach(element => {
  
  // Each marker on the map.
  var popup = '<h3>'+element.name+'</h3><small>' ;
  popup += element.address;
  popup += '<br /><small class="quiet">';
  
  if (checkElement(element.city)){
    popup += element.city + ' - ';
  }
  if (checkElement(element.state)){
    popup += element.state + ' - ';
  }
  if (checkElement(element.country)){
    popup += element.country;
  }
  popup += '</small>';


  if (checkElement(element.phone)){
    popup += '<br/>' + element.phone;
  }

  if (checkElement(element.link)){
    popup += '<br/><a href="'+element.link+'" target="_blank">' + element.link + '</a>';
  }

  
  var listing = listings.appendChild(document.createElement('div'));
  listing.className = 'item';

  var link = listing.appendChild(document.createElement('a'));
  link.href = '#';
  link.className = 'title';
  link.target = "_blank";
  link.innerHTML = element.name;
  link.innerHTML += '<br /><small class="quiet">' + element.address + '</small>';
  
  
  var details = listing.appendChild(document.createElement('small'));
  details.className = 'quiet';

  if (checkElement(element.city)){
    details.innerHTML += element.city + ' - ';
  }
  if (checkElement(element.state)){
    details.innerHTML += element.state + ' - ';
  }
  if (checkElement(element.country)){
    details.innerHTML += element.country;
  }

  if (checkElement(element.phone)){
    details.innerHTML += '<br />' + element.phone;
  }
 
  details.appendChild(document.createElement('br'));
  if (checkElement(element.link)){
    var link2 = details.appendChild(document.createElement('a'));
    link2.innerHTML = element.link ;
    link2.href = element.link;
    link2.target = "_blank";
  }
  var marker = L.marker([element.latitude, element.longitude]).addTo(map);


  // Marker interaction
  marker.on('click', function(e) {
    // 1. center the map on the selected marker.
    // map.panTo(locale.getLatLng());

    // 2. Set active the markers associated listing.
    setActive(listing);
  });

  
  link.onclick = function() {
    setActive(listing);
    map.setView({lat:element.latitude, lng:element.longitude}, 16);
    
    map.panTo({lat:element.latitude, lng:element.longitude});
    
    marker.openPopup();
    return false;
  };
  
  popup += '</small>';
  marker.bindPopup(popup);
  map.invalidateSize();
  console.log("Map updated");

});

function checkElement(prop){
  return prop && prop.length && prop != undefined;
}

function setActive(el) {
    var siblings = listings.getElementsByTagName('div');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].className = siblings[i].className
        .replace(/active/, '').replace(/\s\s*$/, '');
    }

    el.className += ' active';
  }



// Create a Tile Layer and add it to the map
var tiles = new L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  minZoom: '6'}).addTo(map);


  } catch(e) { console.error(e); }
})();
})();
